import axios from "axios";
import levels from "../../models/workflow/levels";
import { getConfig } from "@/config";

class service {
  constructor() {
    this._config = null;
  }

  get config() {
    if (!this._config) {
      const cfg = getConfig();
      if (!cfg) throw new Error("Config not loaded");
      this._config = cfg;
    }
    return this._config;
  }

  getLevels() {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios
      .get(`${url}/workflow/niveles`, { headers })
      .then(({ data }) => {
        return data.map((item) => {
          return levels.fromJson(item);
        });
      });
  }

  new(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    const operid = localStorage.getItem("operId");
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    let payload = {
      nombre: data.name,
      valor: parseInt(data.value, 10),
    };
    return axios.post(`${url}/workflow/niveles`, payload, { headers });
  }
  delete = (data) => {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const empId = localStorage.getItem("empId");
    const nivelid = data;

    return axios.delete(`${url}/workflow/niveles/${nivelid}`, {
      headers,
    });
  };

  edit(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;

    let headers = {
      Authorization: `Bearer ${token}`,
    };
    const nivelid = data.id;

    let payload = {
      nombre: data.name,
      valor: parseInt(data.value, 10),
    };

    return axios
      .patch(`${url}/workflow/niveles/${nivelid}`, payload, { headers })
      .then(() => {});
  }
}
export default service;
